// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__31DTd","selected":"Chip_selected__2XkeB"};